import { forwardRef } from "react";
import { NavLink } from "react-router-dom";
import classNames from "classnames";
import type { NavLinkProps } from "react-router-dom";
import styles from "./styles.module.css";

export const AppNavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ children, to, ...props }, ref) => {
    return (
      <NavLink
        ref={ref}
        to={to}
        className={({ isActive }) => classNames(styles.navlink, { [styles.active]: isActive })}
        {...props}
      >
        {children}
      </NavLink>
    );
  },
);
